<template>
  <CafeteriaRequestsForm :typeEndPoint="'cafeteriaRequestsShow'" :dataParams="this.$route.params" />
</template>
<script>
import CafeteriaRequestsForm from '@/components/modules/cafeteria/requests/form'
export default {
  name: 'CafeteriaRequestsEdit',
  components: {
    CafeteriaRequestsForm
  },
  mounted () {
    console.log(this.$route.params)
  }
}
</script>



// WEBPACK FOOTER //
// src/views/cafeteria/requests/edit.vue